export default "__VITE_ASSET__Bs5_vHm0__"